import { initializeApp, getApps, getApp } from 'firebase/app';
import { getAuth, indexedDBLocalPersistence, browserLocalPersistence, setPersistence } from 'firebase/auth';
import { getFirestore, initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';
import { logger } from '../utils/logger';

const firebaseConfig = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID
};

export const isDemoMode = false;

// getApp() safely returns existing instance on PWA re-open
const app = getApps().length > 0 ? getApp() : initializeApp(firebaseConfig);

// getAuth is idempotent — safe to call multiple times, always returns the same instance
export const auth = getAuth(app);

// Nova forma recomendada de ativar persistência offline (Firestore v10.5+)
export const db = initializeFirestore(app, {
    localCache: persistentLocalCache({
        tabManager: persistentMultipleTabManager()
    }),
    experimentalForceLongPolling: true
});

// Set Auth persistence to IndexedDB at module load time (survives PWA close on all platforms)
// Fallback to localStorage for private/incognito browsers
export const persistenceInitPromise = setPersistence(auth, indexedDBLocalPersistence)
    .catch(() => {
        logger.warn('[Auth] IndexedDB unavailable, falling back to localStorage');
        return setPersistence(auth, browserLocalPersistence);
    });

export const storage = getStorage(app);
export const functionsApi = getFunctions(app);